import { bool, func, string } from "prop-types";
import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { borderRadius } from "theme";
import { colorVariants } from "theme/constants";

import FnrTypography from "UI/FnrTypography";
import { motion } from "motion/react";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrDismissibleError from "UI/FnrDismissibleError";
import FnrTappyShrink from "UI/FnrTappyShrink";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

const FlexMotion = styled(motion.div)`
  display: flex;
`;

const SFnrButtonWrapper = styled(FnrButtonWrapper)`
  ${borderRadius}
  ${({
    $addHover,
    theme: {
      palette: { brandFnBlue },
    },
  }) =>
    $addHover
      ? `&:hover {background-color: ${brandFnBlue}33}; margin-right: -6px; padding: 6px 6px 6px 12px;`
      : ""}
  ${({ disabled }) => (disabled ? "opacity: .5;" : "opacity: 1;")}
  transition: opacity 300ms, background-color 300ms;
`;

const DroopCorrection = styled("div")`
  margin-bottom: -2px;
`;

const FnrResendCode = ({
  onClick,
  isLoading = false,
  disabled = false,
  isDark,
  dark = isDark,
  errorMessage,
  clearErrorMessage,
  isLegacy,
  addHover,
}) => {
  const [rotation, setRotation] = useState(0);
  const [hasIncremented, setHasIncremented] = useState(false);

  useEffect(() => {
    if (isLoading && !hasIncremented) {
      setRotation(rotation + 360);
      setHasIncremented(true);
    }
    if (!isLoading && hasIncremented) {
      setHasIncremented(false);
    }
  }, [isLoading, rotation, hasIncremented]);

  return (
    <FnrVerticalGap gap={0}>
      <FnrTappyShrink>
        <SFnrButtonWrapper
          data-cy="resendCode"
          onClick={!disabled ? onClick : null}
          disabled={disabled}
          $addHover={addHover}
        >
          <FnrHorizontalGap gap={0}>
            <FnrTypography
              type={isLegacy ? undefined : "copy"}
              fontSize="sm"
              color={dark ? "textLight" : "brandFnBlue"}
            >
              Resend Code
            </FnrTypography>
            <DroopCorrection>
              <FlexMotion
                animate={{
                  rotate: rotation,
                  transition: {
                    duration: 0.8,
                  },
                }}
              >
                <SFnrContainedIcon
                  size="xs"
                  colorVariant={dark ? colorVariants.dark : colorVariants.light}
                  color="brandFnBlue"
                  icon="fa-redo fas"
                />
              </FlexMotion>
            </DroopCorrection>
          </FnrHorizontalGap>
        </SFnrButtonWrapper>
      </FnrTappyShrink>
      <FnrDismissibleError
        errorMessage={errorMessage}
        onDismiss={clearErrorMessage}
        translateX={-96}
      />
    </FnrVerticalGap>
  );
};

const SFnrContainedIcon = styled(FnrContainedIcon)`
  margin-bottom: 3px;
  background-color: #ffffff00;
`;

FnrResendCode.propTypes = {
  isLoading: bool,
  disabled: bool,
  isDark: bool,
  dark: bool,
  onClick: func,
  errorMessage: string,
  clearErrorMessage: func,
  isLegacy: bool,
  addHover: bool,
};

export default FnrResendCode;
